import { useEffect, useMemo, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSlug from 'rehype-slug';
import GithubSlugger from 'github-slugger';

const WIKI_URL = `${process.env.PUBLIC_URL}/slope-sliders-wiki.md`;

// Pull every `## Heading` out of the raw markdown and slug it the same way
// rehype-slug will, so the sidebar links line up with the rendered anchors.
function buildToc(markdown) {
  const slugger = new GithubSlugger();
  const toc = [];
  let inFence = false;
  for (const line of markdown.split('\n')) {
    if (line.trim().startsWith('```')) inFence = !inFence;
    if (inFence) continue;
    const m = /^##\s+(.+?)\s*$/.exec(line);
    if (m) toc.push({ text: m[1], id: slugger.slug(m[1]) });
  }
  return toc;
}

export default function Wiki() {
  const [md, setMd] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    fetch(WIKI_URL)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then((text) => alive && setMd(text))
      .catch(() => alive && setError(true));
    return () => {
      alive = false;
    };
  }, []);

  const toc = useMemo(() => (md ? buildToc(md) : []), [md]);

  if (error) {
    return (
      <p style={{ color: '#5a6a85' }}>
        The guide could not be loaded right now.{' '}
        <a href={WIKI_URL}>Open the raw source &rarr;</a>
      </p>
    );
  }
  if (!md) return <p style={{ color: '#5a6a85' }}>Loading the guide&hellip;</p>;

  return (
    <div className="wiki-layout">
      <nav className="wiki-toc" aria-label="Guide contents">
        <p className="wiki-toc-title">On this page</p>
        {toc.map((s) => (
          <a key={s.id} href={`#${s.id}`} className="wiki-toc-link">
            {s.text}
          </a>
        ))}
      </nav>
      <article className="wiki-md">
        <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSlug]}>
          {md}
        </ReactMarkdown>
      </article>
    </div>
  );
}
